import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { AppDispatcher, APIUtils } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import ProductGroupConstants from '../../../constants/ProductGroupConstants';
import ProductGroupStore from './ProductGroupStore';

const { dispatchServerAction, dispatchViewAction } = AppDispatcher;

function loadProductGroup(pages = 1, forceProductLoad = false) {
  const { fetching, perPage, productDataWasLoaded } = ProductGroupStore.getState();
  const { featured_products_taxon_permalink, configWasLoaded } = OlsConfigStore.getState();
  const hasLoadedData = productDataWasLoaded && !forceProductLoad;

  if (!featured_products_taxon_permalink || fetching || hasLoadedData || !configWasLoaded) {
    return;
  }

  dispatchViewAction({
    type: ProductGroupConstants.LOAD_PRODUCT_GROUP
  });

  const attrs = {
    page: pages,
    per_page: perPage,
    taxon_permalink: featured_products_taxon_permalink
  };

  APIUtils.loadProducts(attrs)
    .then(function (data) {
      return productGroupWasLoaded(data);
    })
    .catch(function (data) {
      return errorLoadingProductGroupData(data.error);
    });
}

export function errorLoadingProductGroupData(error) {
  dispatchServerAction({
    type: ProductGroupConstants.ERROR_LOADING_PRODUCT_GROUP_DATA,
    error
  });
}

export function productGroupWasLoaded(data) {
  dispatchServerAction({
    type: ProductGroupConstants.PRODUCT_GROUP_WAS_LOADED,
    data: data
  });
}

export default { loadProductGroup };
